import request from "@/utils/request";
export function getPage(condition, pagination) {
  return request({
    url: "/crm/outsource/page",
    method: "post",
    data: { condition: condition, pagination: pagination },
  });
}
export function saveOrUpdate(data) {
  return request({
    url: "/crm/outsource/saveOrUpdate",
    method: "post",
    data,
  });
}

export function get(id) {
  return request({
    url: "/crm/outsource/get",
    method: "get",
    params: { id },
  });
}

export function deleteById(id) {
  return request({
    url: "/crm/outsource/deleteById",
    method: "post",
    data: { id: id },
  });
}
export function submit(id) {
  return request({
    url: "/crm/outsource/submit",
    method: "post",
    data: { id: id },
  });
}

export function getPageFinished(condition, pagination) {
  return request({
    url: "/crm/outsource/finished/page",
    method: "post",
    data: { condition: condition, pagination: pagination },
  });
}
export function saveOrUpdateFinished(data) {
  return request({
    url: "/crm/outsource/finished/saveOrUpdate",
    method: "post",
    data,
  });
}

export function getFinished(outsourceProcessingId,pagination) {
  return request({
    url: "/crm/outsource/finished/getAll",
    method: "get",
    params: { outsourceProcessingId , pagination},
  });
}

export function deleteByIdFinished(id) {
  return request({
    url: "/crm/outsource/finished/deleteById",
    method: "post",
    data: { id: id },
  });
}
export function saveOrUpdateExpense(data) {
  return request({
    url: "/crm/outsource/saveOrUpdateExpense",
    method: "post",
    data,
  });
}
export function getPurchase(id) {
  return request({
    url: "/crm/outsource/purchase/get",
    method: "get",
    params: { id },
  });
}
export function saveOrUpdatePurchase(data) {
  return request({
    url: "/crm/outsource/purchase/saveOrUpdate",
    method: "post",
    data,
  });
}
export function downloadOutsourceProcessingTemplate() {
  return request({
    url: '/crm/outsource/line/downloadTemplate',
    method: 'post',
    responseType: 'blob'
  })
}
export function downloadOutsourceProcessingInputTemplate() {
  return request({
    url: '/crm/outsource/input/downloadTemplate',
    method: 'post',
    responseType: 'blob'
  })
}
export function downloadOutsourceProcessingOutputTemplate() {
  return request({
    url: '/crm/outsource/output/downloadTemplate',
    method: 'post',
    responseType: 'blob'
  })
}

